import Button from "@/components/atoms/button";
import Input from "@/components/atoms/input";
import { BUTTON_MSG } from "@/consts/message";
import { showAlertPopup } from "@/core/presenter/controller/PopupController";
import * as ViewModel from '@/core/presenter/viewModel';
import { replaceNewLineToTag } from "@/utils";
import clsx from "clsx";
import { useCallback } from "react";

interface IProps {
    isWritting: boolean;
    sendAddress: string;
    onChangeSendAddress: (e: React.SyntheticEvent<HTMLInputElement>) => void;
    onClickDeleteBtn: () => void;
    onPaste: (text: string) => void;
    onClickCameraBtn: () => void;
}

const SendInputForm = ({isWritting, sendAddress, onChangeSendAddress, onClickDeleteBtn, onPaste, onClickCameraBtn}: IProps) => {
    /** 붙여넣기 핸들링 이벤트 */
    const handlePaste = useCallback(async () => {
        try {
            // 기본 Clipboard API 시도
            if (navigator.clipboard?.readText) {
                const text = await navigator.clipboard.readText();
                onPaste(text);
                return;
            }

            // Permissions API를 통한 권한 요청
            if (navigator.permissions) {
                const result = await navigator.permissions.query({ name: 'clipboard-read' as PermissionName });
                if (result.state === 'granted' || result.state === 'prompt') {
                    const text = await navigator.clipboard.readText();
                    onPaste(text);
                    return;
                }
            }

            showAlertPopup(replaceNewLineToTag(BUTTON_MSG.CLIPBOARD_NOT_SUPPORTED), true);
            
        } catch (err) {
            console.error('Failed to read clipboard:', err);
            showAlertPopup(replaceNewLineToTag(BUTTON_MSG.CLIPBOARD_NOT_SUPPORTED), true);
        }
    }, [onPaste]);

    return (
        <>
            <div className="input-group">
                <Input type="text" value={sendAddress} className="address-input" id="addressInput" placeholder="공개 주소(T) 입력" validatorType={ViewModel.InputValidatorType.ALPHABET_NUMBER} onChange={onChangeSendAddress} />
                <i id="clearIcon" className="bi bi-x-circle" 
                   style={{ display: isWritting ? 'inline-block' : 'none' }} 
                   onClick={onClickDeleteBtn}></i>
                {sendAddress.length === 0 && <i className="bi bi-qr-code-scan" style={{ display: 'inline-block' }} onClick={onClickCameraBtn}></i>}
            </div>
            <Button 
                caption="붙여넣기" 
                className={clsx('paste-button paste-button-snd', { 'none_important': isWritting, 'show_important': !isWritting })} 
                onClick={handlePaste} 
            />
        </>
    )
}

export default SendInputForm;